export const getProductSelection = (type, excludedOfferIds, includedOfferIds) => {
    if (type === 'SELECTED_PRODUCTS') {
        return {
            type,
            offerIds: includedOfferIds,
        };
    }
    if (type === 'ALL_PRODUCTS' && !!excludedOfferIds.length) {
        return {
            type: 'EXCLUDED_PRODUCTS',
            offerIds: excludedOfferIds,
        };
    }
    return { type };
};
